module.exports = __webpack_public_path__ + "static/media/Temp2small.305443f0.png";